// DocumentViewer.js
import PropTypes from 'prop-types';
import { Card, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';



const DocumentViewer = ({ documentSource, isView, isEdit }) => {
    const [documentExists, setDocumentExists] = useState(true);
    const iframeRef = useRef(null);

    useEffect(() => {
        const checkDocumentExistence = async () => {
            try {
                if (isView || isEdit) {
                    await axios.head(documentSource);
                } else {
                    const file = documentSource[0];
                    if (!file) {

                        setDocumentExists(false);
                        return;
                    }

                    const objectURL = URL.createObjectURL(file);
                    const response = await fetch(objectURL, { method: 'HEAD' });

                    await axios.head(objectURL);
                }
            } catch (error) {
                setDocumentExists(false);
            }
        };
        if (isView) {
            checkDocumentExistence();
        }

    }, [documentSource, isView, isEdit]);


    const iframeStyle = {
        width: '100%',
        height: '800px',
        border: '10px solid black',
        '#download':
            { display: 'block' },

    };
    const handleLoad = () => {
        const iframe = iframeRef.current;
        console.log("iframe", iframe);

        if (isView && iframe) {
            const contentDocument = iframe.contentDocument || iframe.contentWindow.document;

            // Your plain JavaScript code to hide an element within the iframe
            const toolbarViewerRight = contentDocument.getElementById('toolbarViewerRight');

            if (toolbarViewerRight) {
                toolbarViewerRight.style.display = 'none';
            }
        }
    };

    return (
        <div>
            {documentExists ? (
                <iframe
                    src={isView ? documentSource : URL.createObjectURL(documentSource[0])}
                    ref={iframeRef}
                    title="Document Viewer"
                    width="100%"
                    height="800"
                    frameBorder="10"
                    style={iframeStyle}
                    onLoad={handleLoad}
                >
                    Your browser does not support the iframe tag.
                </iframe>
            ) : (
                <div>
                    <Typography variant="body1" color="error.main" >Document not found at the given path!</Typography>
                    {/* You can customize the error message further if needed */}
                </div>
            )}
        </div>
    );
};

DocumentViewer.propTypes = {
    documentSource: PropTypes.oneOfType([
        PropTypes.string, // for direct document source
        PropTypes.arrayOf(PropTypes.instanceOf(File)), // for file input
    ]),
    isView: PropTypes.bool,
    isEdit: PropTypes.bool,
};

export default DocumentViewer;
